import {RangeurConfiguration} from "../models/Models";
import EventPublicApiClientFactory from "../models/EventPublicApiClientFactory";
import {useEffect, useState} from "react";
import {TimeSlotReservationData} from "../models/ModelsEventPublic";

interface RangeurViewProps {
    rangeurConfig: RangeurConfiguration | undefined;
}

const RangeurView : React.FC<RangeurViewProps> = ({rangeurConfig}) => {
    const apiClient = EventPublicApiClientFactory.GetApiClient();

    const [timeSlotDatas, setTimeSlotDatas] = useState<TimeSlotReservationData>()
    const [isFullDayView, setIsFullDayView] = useState(true)
    const [isMorningSelected, setIsMorningSelected] = useState(false)
    const [lastUpdatedDate, setLastUpdatedDate] = useState<number>(0)

    useEffect(() => {
        if (timeSlotDatas?.createdDateTime){
            const lastUpdate = lastUpdatedDate + 300000;

            console.log('-------------------------------------')
            console.log(Date.now())
            console.log(lastUpdate)
            console.log(Date.now() > lastUpdate)

            if (Date.now() > lastUpdate || lastUpdatedDate == 0){
                loadData()
            }
        }else{
            loadData()
        }

    }, [rangeurConfig]);

    async function loadData(){
        const result = await apiClient.api.publicEventsLiveDataRangeurDataDetail(rangeurConfig?.shootingRangeNumber??"", rangeurConfig?.distanceId??0, `${rangeurConfig?.eventId}`)
        if (result.ok){
            setTimeSlotDatas(result.data)
            if (result.data && result.data.createdDateTime){
                setLastUpdatedDate(Date.now())
            }

        }
    }

    return rangeurConfig ? <div>
        <table className={"table table-striped table-row-segregation"}>
            <thead>
            <tr>
                <th className={'border-black border-start border-bottom border-end'}></th>
                {
                    (timeSlotDatas?.times && timeSlotDatas?.times.length > 0) ? timeSlotDatas.times[0].groups?.map(g => {

                        const elements = g.items?.map(i => {
                            return <th className={'border-black border-start border-bottom border-end'}>Scheibe {i.laneNumber}</th>
                        })

                        if (g.groupId != 0) {
                            elements?.unshift(<th className={"border-start border-black sticky"}>Stich</th>)
                        }

                        return elements;
                    }) : <span></span>
                }
            </tr>
            </thead>
            <tbody>
            {
                timeSlotDatas?.times?.filter(t => isFullDayView ? true : isMorningSelected == t.isMorning).map(t => {
                    return <tr>
                        <th className={'border-black border'}>{t.time}</th>
                        {
                            t.groups?.map(g => {
                                var items = g.items?.map(tsr => {
                                    return <td className={'border-black border'}>
                                        {tsr.assignedOrganizationName}<br/><strong>{tsr.participantName}</strong>
                                    </td>
                                });

                                if (g.groupId != 0) {
                                    items?.unshift(<th className={"border-start border-black"}>
                                        {g.shootingProgramDefinitionName}
                                    </th>)
                                }

                                return items;
                            })
                        }
                    </tr>
                })
            }
            </tbody>
        </table>
    </div> : <div></div>
}

export default RangeurView;